<template>
  <div class="profile-overview">
    <img class="avatar" :src="user.avatar" v-if="user.avatar">
    <i class="avatar fa fa-user" aria-hidden="true" v-if="!user.avatar"></i>
    <img class="avatar" :src="vehicle.avatar" v-if="vehicle.avatar">
    <i class="avatar fa fa-motorcycle" aria-hidden="true" v-if="!vehicle.avatar"></i>
    <p>
      {{ user.name }} <br>
      {{ vehicle.name }}
    </p>
    <p class="right">
      <br>
      {{ vehicle.brand }} {{ vehicle.model }}
    </p>
  </div>
</template>

<style lang="scss">
.profile-overview {

  .avatar {
    background: white;
    border: 1px solid #dcdcdc;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    margin-top: 2px;
    margin-left: 4px;
    float: left;
    font-size: 18px;
    color: #646464;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img.avatar {
    object-fit: cover;
  }

  p {
    padding: 0;
    margin: 0 0 0 20px;
    line-height: 18px;
    float: left;
    font-size: 14px;
  }

  p.right {
    float: right;
    margin-right: 10px;
    font-weight: bold;
    font-size: 12px;
  }
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.user,
      vehicle: state => state.vehicle
    })
  }
}
</script>




// WEBPACK FOOTER //
// ProfileOverview.vue?4986db58